export const all = [
    {
      id: 1,
      title: "Sabay News",
      img:"assets/sabayNew.png",
      link: "https://sameangty.github.io/sabaynewsclone.github.io/"
    },
    {
      id: 2,
      title: "E-Shop",
      img:
        "https://wp-tutorials.tech/wp-content/uploads/2020/10/jquery-square-logo-1024x1024.png",
      link: "https://sameangty.github.io/sameangty-jquery.github.io/#"
    },
    {
      id: 3,
      title: "Social Media",
      img:"https://1000logos.net/wp-content/uploads/2021/04/Facebook-logo.png",
      link: "https://sameangty.github.io/facebookclone/"
    },
    {
      id: 4,
      title: "MERN",
      img:
        "https://www.nicepng.com/png/detail/247-2475175_ecommerce-e-commerce-website-logo.png",
      link:"https://github.com/SamEangTy/react_node_express_mysql"
    },
    {
      id: 5,
      title: "PHP",
      img:"https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/PHP-logo.svg/1200px-PHP-logo.svg.png",
      link:"https://github.com/SamEangTy/php-crud"
    },
    {
      id: 6,
      title: "React",
      img:"https://www.cozumpark.com/wp-content/uploads/2022/12/react-nedir-react-ile-neler-yapilabilir-jpeg.webp",
      link:"https://sameangty-yummy.netlify.app/"
    },
   
  ];
  
  export const design = [
    {
      id: 1,
      title: "Sabay News ",
      img:"assets/sabayNew.png",
      link: "https://sameangty.github.io/sabaynewsclone.github.io/"
    },
   
  ];
  
  export const jquery = [
    {
      id: 1,
      title: "E-Shop",
      img:"https://wp-tutorials.tech/wp-content/uploads/2020/10/jquery-square-logo-1024x1024.png",
      link: "https://sameangty.github.io/sameangty-jquery.github.io/#"
    },
    
  ];
  
  export const react = [
    {
      id: 1,
      title: "Social Media",
      img:"https://img.freepik.com/premium-vector/blue-social-media-logo_197792-1759.jpg",
      link: "https://sameangty.github.io/facebookclone/"

    },
    {
      id: 2,
      title: "React",
      img:"https://www.cozumpark.com/wp-content/uploads/2022/12/react-nedir-react-ile-neler-yapilabilir-jpeg.webp",
      link:"https://sameangty-yummy.netlify.app/"
    },
   
   
  ];
  
  export const mern = [
    {
      id: 1,
      title: "MERN",
      img:"https://www.nicepng.com/png/detail/247-2475175_ecommerce-e-commerce-website-logo.png",
      link: "https://github.com/SamEangTy/react_node_express_mysql"
    },
   
  ];
  export const php = [
    {
      id: 1,
      title: "PHP",
      img:"https://avatars.githubusercontent.com/u/25158?s=280&v=4",
      link: "https://github.com/SamEangTy/php-crud"
    },
   
  ];
  